export const AI_AGENT_DOCUMENT_MAX_CONTENT_BYTES = 20 * 1024;
export const AI_AGENT_DOCUMENT_ORG_QUOTA_BYTES = 5 * 1024 * 1024;
//# sourceMappingURL=documentTypes.js.map